import { put, select } from 'redux-saga/effects';

import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';

import * as InsuranceActions from '../actions';
import * as InsuranceConstants from '../constants';
import * as InsuranceSelectors from '../selectors';

export class WatchCarInstanceUpdate {
  primary = true;
  state = {
    [CarInstanceConstants.VALUE_FIELDS.BRAND]: '',
    [CarInstanceConstants.VALUE_FIELDS.MODEL]: '',
    [CarInstanceConstants.VALUE_FIELDS.VERSION]: '',
  };
  watch = false;

  // eslint-disable-next-line class-methods-use-this
  *selectBrand({ brand }) {
    const markAsPTS = yield select(
      InsuranceSelectors.selectDataValue(InsuranceConstants.DATA_FIELDS.MARK_AS_PTS)
    );

    if (!markAsPTS) {
      yield put(
        InsuranceActions.updateDataValues({ [InsuranceConstants.DATA_FIELDS.MARK_AS_PTS]: brand })
      );
    }

    yield put(InsuranceActions.selectBrand());
  }

  // eslint-disable-next-line class-methods-use-this
  *selectModel({ model }) {
    const modelAsPTS = yield select(
      InsuranceSelectors.selectDataValue(InsuranceConstants.DATA_FIELDS.MODEL_AS_PTS)
    );

    if (!modelAsPTS) {
      yield put(
        InsuranceActions.updateDataValues({ [InsuranceConstants.DATA_FIELDS.MODEL_AS_PTS]: model })
      );
    }

    yield put(InsuranceActions.selectModel());
  }

  *watcher() {
    if (!this.watch) {
      return;
    }

    const fields = Object.keys(this.state);

    const carInstance = yield select(CarInstanceSelectors.selectValues);

    if (this.primary) {
      this.primary = false;

      fields.forEach((field) => {
        this.state[field] = carInstance[field];
      });

      return;
    }

    for (const field of fields) {
      const current = carInstance[field];
      const previous = this.state[field];
      const equal = current === previous;

      if (equal) {
        continue;
      }

      this.state[field] = current;

      // eslint-disable-next-line default-case
      switch (field) {
        case CarInstanceConstants.VALUE_FIELDS.BRAND:
          yield* this.selectBrand({ brand: current });
          break;
        case CarInstanceConstants.VALUE_FIELDS.MODEL:
          yield* this.selectModel({ model: current });
          break;
        case CarInstanceConstants.VALUE_FIELDS.VERSION:
          yield put(InsuranceActions.selectVersion());
          break;
      }
    }
  }
}
